export default function haveHttp(s) {
    // Expresión regular para buscar "http://" o "https://"
    var expresion = /^(https?:\/\/)/;
    
    // Testeamos si la cadena comienza con "http://" o "https://"
    // o si el string está vacío
    return expresion.test(s) || s === '';
  }